export default {"src":"/_next/static/media/refresh.d2dae9ff.svg","height":24,"width":24};